import React, { useState, useEffect, useMemo } from "react";
import DashboardWrapper from "../../components/DashboardWrapper";
import CrudTable from "../../components/dashboard/table/CrudTable";
import productService from "../../services/productService";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrumb from "../../components/Breadcrumbdashboard";

export default function HomeSectionProducts() {
  const [sections, setSections] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // ✅ FETCH DATA
  const fetchData = async () => {
    try {
      setLoading(true);

      const res = await productService.getAllHomeSections();
      const sectionsArray = Array.isArray(res.data)
        ? res.data
        : res.data?.data || [];
      setSections(sectionsArray);

      const productRes = await productService.getAllProducts();
      const productsArray = Array.isArray(productRes.data)
        ? productRes.data
        : productRes.data?.data || [];
      setProducts(productsArray);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // ✅ DELETE
  const handleDelete = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#FB6C22",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await productService.deleteHomeSection(id);

          // ✅ SUCCESS POPUP (LIKE YOUR IMAGE)
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: "Product has been deleted.",
            confirmButtonColor: "#FB6C22",
          });

          fetchData();
        } catch (error) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Failed to delete product.",
          });
        }
      }
    });
  };

  // ✅ STATUS TOGGLE
  const handleToggleStatus = async (item) => {
    try {
      await productService.updateHomeSection(item.id, {
        name: item.name,
        // sort_order: item.sort_order,
        status: item.status ? 0 : 1,
        products: (item.products || []).map((p) =>
          typeof p === "object" ? p.id : p,
        ),
      });

      // ✅ SUCCESS POPUP (same like your image)
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Product status updated.",
        confirmButtonColor: " #FB6C22",
      });

      fetchData();
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to update status.",
      });
    }
  };

  // ✅ TABLE DATA
  const tableData = useMemo(() => {
    return Array.isArray(sections)
      ? sections.map((item, index) => ({
          ...item,
          sl: index + 1,
          products_count: item.products?.length || 0,
        }))
      : [];
  }, [sections]);

  return (
    <DashboardWrapper>
      <div
        className="container-fluid"
        style={{
          marginTop: "10px",
          paddingTop: "0",
          paddingBottom: "0",
        }}
      >
        {/* TOP ROW */}
        <div
          className="d-flex justify-content-between align-items-center"
          style={{
            marginBottom: "8px",
            padding: "0 4px",
          }}
        >
          {/* Home Section Products - LEFT */}
          <h4
            className="mb-0"
            style={{
              fontSize: "20px",
              fontWeight: "500",
              color: "#374151",
            }}
          >
            Home Section Products
          </h4>

          {/* Breadcrumb - RIGHT */}
          <div style={{ margin: 0 }}>
            <Breadcrumb />
          </div>
        </div>

        {/* TABLE CARD */}
        <div
          className="card shadow"
          style={{
            marginTop: "0",
            marginBottom: "10px",
          }}
        >
          {/* CARD HEADER */}
          <div
            className="card-header d-flex justify-content-start align-items-center"
            style={{
              padding: "8px 16px",
              minHeight: "50px",
            }}
          >
            {/* Create Home Section - LEFT */}
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => navigate("/admin/create-home-section")}
              style={{
                padding: "7px 16px",
                fontSize: "14px",
              }}
            >
              Create Home Section
            </button>
          </div>

          {/* TABLE BODY */}
          {loading ? (
            <div
              className="d-flex justify-content-center align-items-center"
              style={{
                minHeight: "150px",
                padding: "20px",
              }}
            >
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : (
            <div
              className="card-body"
              style={{
                padding: "8px 16px 10px",
              }}
            >
              <CrudTable
                data={tableData}
                columns={["sl", "name", "products_count", "status"]}
                onEdit={(item) => {
                  navigate(`/admin/edit-home-section/${item.id}`, {
                    state: { section: item },
                  });
                }}
                onDelete={handleDelete}
                onToggleStatus={handleToggleStatus}
              />
            </div>
          )}
        </div>
      </div>
    </DashboardWrapper>
  );
}
